module.exports = __webpack_public_path__ + "media/images/logo-weo-15-ans-b09bd81138ba17b01f49f774b7756328.png";